export const GET_PRODUCT_LOADING = "GET/product/loading";
export const GET_PRODUCT_ERROR = "GET/product/error";
export const GET_PRODUCT_SUCCESS = "GET/product/success";

export const GETSINGLE_PRODUCT_LOADING = "GETSINGLE/product/loading";
export const GETSINGLE_PRODUCT_ERROR = "GETSINGLE/product/error";
export const GETSINGLE_PRODUCT_SUCCESS = "GETSINGLE/product/success";

export const ADD_PRODUCT_LOADING = "ADD/product/loading";
export const ADD_PRODUCT_ERROR = "ADD/product/error";
export const ADD_PRODUCT_SUCCESS = "ADD/product/success";

export const UPDATE_PRODUCT_LOADING = "UPDATE/product/loading";
export const UPDATE_PRODUCT_ERROR = "UPDATE/product/error";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE/product/success";

export const DELETE_PRODUCT_LOADING = "DELETE/product/loading";
export const DELETE_PRODUCT_ERROR = "DELETE/product/error";
export const DELETE_PRODUCT_SUCCESS = "DELETE/product/success";
